import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=0ac10579&scoped=true&"
import script from "./teacher.vue?vue&type=script&lang=js&"
export * from "./teacher.vue?vue&type=script&lang=js&"
import style0 from "./teacher.vue?vue&type=style&index=0&id=0ac10579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac10579",
  null
  
)

export default component.exports